import React from 'react';
import useResponsive from '../hooks/useResponsive';

const ResponsiveWalletSection = ({ 
  walletData = [], 
  className = '' 
}) => {
  const { isMobile, isTablet } = useResponsive();

  const getGridColumns = () => {
    if (isMobile) return '1fr';
    if (isTablet) return '1fr 1fr';
    return '1fr 1fr 1fr';
  };

  return (
    <div className={`responsive-wallet-section ${className}`}>
      <div className="row cstm_row_overwrite">
        {walletData.map((item, index) => (
          <div key={index} className={isMobile ? "col-12 mb-3" : "col-3"}>
            <div className="user_detail_container">
              <ul className="selected_user_detail">
                <li>
                  <p>{item.label}:</p>
                  <p style={{ 
                    color: '#fff', 
                    fontWeight: '600',
                    fontSize: isMobile ? 'var(--font-size-lg)' : 'var(--font-size-xl)'
                  }}>
                    {item.value || "---"}
                  </p>
                </li>
              </ul>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ResponsiveWalletSection;

